import {AppConfig} from "../AppConfig";
import Cookies from 'js-cookie'

export const globalSession = new Session();

function Session() {
    //this.Cookies = new Cookies();
    this.rs = require('jsrsasign');
    this.getToken = function () {
        return Cookies.get(AppConfig.cookie.token);
    }
    this.setToken = function (token) {
        Cookies.set(AppConfig.cookie.token, token, {path: "/"});
    }
    this.removeToken = function () {
        Cookies.remove(AppConfig.cookie.token, {path: "/"});
    }
    this.removeName = function () {
        Cookies.remove(AppConfig.cookie.name, {path: "/"});
    }
    this.removeSurname = function () {
        Cookies.remove(AppConfig.cookie.surname, {path: "/"});
    }

    this.removeSession = function () {
        this.removeName();
        this.removeSurname();
        this.removeToken();
        window.location = AppConfig.pages.login;
    }

    this.setName = function (name) {
        Cookies.set(AppConfig.cookie.name, name, {path: '/'});
    }

    this.setSurname = function (surname) {
        Cookies.set(AppConfig.cookie.surname, surname, {path: '/'});
    }

    this.getName = function () {
        return Cookies.get(AppConfig.cookie.name, {path: "/"});
    }

    this.getSurname = function () {
        return Cookies.get(AppConfig.cookie.surname, {path: "/"});
    }

    this.getFullName = function () {
        return this.getName() + " " + this.getSurname();
    }

    this.check = function () {
        const token = this.getToken();
        if (token === null) return false;


        //const a = "1eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMDAiLCJpYXQiOjE1OTI4MzQ4ODgsImV4cCI6MTU5MjkyMTI4OH0.32FKXBoxoRz_lGIkheYcN4Dy75d0SFN_JEWArbj19Xnwb8zEk0IW6JLJiTCyaHvB_pizdR9z5zfKSct_Dv4Dtg";

        try {
            const tSplit = token.split(".");
            //const pHeader = this.rs.KJUR.jws.JWS.readSafeJSONString(this.rs.b64utoutf8(b[0]));
            const pClaim = this.rs.KJUR.jws.JWS.readSafeJSONString(this.rs.b64utoutf8(tSplit[1]));
            //const sHeader = JSON.stringify(pHeader, null, "  ");
            const sClaim = JSON.stringify(pClaim, null, "  ");

            let ts = Math.floor(Date.now() / 1000);
            let tokenExp = JSON.parse(sClaim);
            return ts < tokenExp["exp"];
        } catch (e) {
            this.removeToken()
            return false;
        }
    }

    this.getAuthToken = function () {
        return {headers: {Authorization: 'Bearer ' + this.getToken()}};
    }
}